import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Search, Car, Route } from "lucide-react";

const LINKS = [["Short-Term Rental", "/rent-a-car"], ["Monthly Rental", "/monthly"], ["Our Fleet", "/fleet"], ["Locations", "/locations"], ["Help & FAQs", "/help"], ["My Account", "/account"]];

export default function NotFound() {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-[#fafcfa]">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-xl w-full text-center" data-testid="not-found-page">
          <div className="relative inline-block mb-6">
            <span className="text-[96px] sm:text-[120px] font-bold text-[#144733] leading-none">4<span className="text-[#009900]">0</span>4</span>
            <Route className="w-10 h-10 text-[#FFDC00] absolute -right-8 top-2 rotate-12" />
          </div>
          <h1 className="heading-upper text-xl sm:text-2xl text-[#144733]">{t("This road doesn't exist — let's get you back on track.")}</h1>
          <p className="text-sm text-[#57685e] mt-2">{t("The page you're after has moved, or never left the depot. Search the site or take one of the main roads below.")}</p>
          <form className="mt-6 flex gap-2" onSubmit={(e) => { e.preventDefault(); if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`); }}>
            <input className="field-input flex-1" placeholder={t("Search vehicles, articles, answers…")} value={q} onChange={(e) => setQ(e.target.value)} data-testid="notfound-search-input" />
            <button type="submit" className="btn-cta rounded px-5 text-xs flex items-center gap-2" data-testid="notfound-search-btn"><Search className="w-4 h-4" />{t("Search")}</button>
          </form>
          <div className="flex flex-wrap justify-center gap-2 mt-6">
            {LINKS.map(([label, to]) => (
              <Link key={to} to={to} className="border border-[#d5ddd5] rounded-full px-4 py-2 text-xs font-semibold text-[#144733] hover:border-[#009900] transition-colors bg-white" data-testid={`notfound-link-${to.replace(/\//g, "")}`}>{t(label)}</Link>
            ))}
          </div>
          <Link to="/" className="btn-cta rounded px-8 py-3 text-xs inline-flex items-center gap-2 mt-8" data-testid="notfound-home-btn"><Car className="w-4 h-4" /> {t("Back to booking")}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
